module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/5p7DFm/tc-custom/9781473894747.jpg?1703360133981",
      "alt": "This image is the cover for the book Superpowers, Rogue States and Terrorism"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Superpowers, Rogue States and Terrorism\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Numerous books have attempted to assess the generational threat from Jihadist-inspired terrorism but few offer any positive advice on solutions. Islamist terrorism is today a fact of life and its potency is vividly illustrated by outrages in otherwise secure Western democracies not to mention overt ISIL aggression in the Middle East and many African States. Without a far better understanding of the Islamic religion, its beliefs, value, hierarchy (or lack of) and different sects, countering the existential threat will be greatly hindered, not to say nearly impossible. In this thoughtful book the author, who combines scholarship with gritty on-the-ground experience, examines numerous options to counter the insidious threat that faces not only Western civilization but the wider world. These range from the extremes such as deportation and internment, through the multifaceted combined actions against hate preachers, intensified intelligence work and border security to comprehensive and inclusive joint action programs. This is an important and timely book on what is today the greatest security threat, written by an acknowledged expert.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Paul Moorcraft\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0